import './calendar-date.scss';

import { Grid, ThemeProvider, Typography } from '@mui/material';
import { format, isMonday } from 'date-fns';
import React, { useEffect, useState } from 'react';

import { calendarDateTheme } from '../../../themes/calendarDateTheme';

interface CalendarDateDisplayProps {
  date: Date;
  isMobile: boolean;
  onClick: () => void;
  className: string;
  startMorning: boolean;
  endAfternoon: boolean;
  morningColorClass: string;
  afternoonColorClass: string;
  colorClass: string;
}

export function CalendarDateDisplay({
  date,
  isMobile,
  onClick,
  className,
  startMorning,
  endAfternoon,
  morningColorClass,
  afternoonColorClass,
  colorClass,
}: CalendarDateDisplayProps) {
  const [classNameFinal, setClassNameFinal] = useState(className);
  useEffect(() => {
    let finalClassName = className;
    if (startMorning) {
      finalClassName = finalClassName + ' ' + morningColorClass + '_start_morning';
    }
    if (endAfternoon) {
      finalClassName = finalClassName + ' ' + afternoonColorClass + '_end_afternoon';
    }
    if (colorClass !== '') {
      finalClassName = finalClassName + ' ' + colorClass;
    }
    setClassNameFinal(finalClassName);
  }, [
    startMorning,
    endAfternoon,
    className,
    morningColorClass,
    afternoonColorClass,
    colorClass,
  ]);

  return (
    <ThemeProvider theme={calendarDateTheme}>
      <Grid
        id={`calendar-date-${format(date, 'yyyy-MM-dd')}`}
        item
        alignItems={'flex-end'}
        justifyContent="center"
        onClick={onClick}
        className={classNameFinal}
      >
        <Typography className="date_number">
          {(!isMobile || isMonday(new Date(date))) && format(date, 'd')}
        </Typography>
      </Grid>
    </ThemeProvider>
  );
}
